import { render, staticRenderFns } from "./formFillupByColDetails.vue?vue&type=template&id=45e5b6b0&"
import script from "./formFillupByColDetails.vue?vue&type=script&lang=js&"
export * from "./formFillupByColDetails.vue?vue&type=script&lang=js&"
import style0 from "./formFillupByColDetails.vue?vue&type=style&index=0&id=45e5b6b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports